module.exports = __webpack_public_path__ + "static/media/BrowserEdge.909b2bd0.png";